import React, { useEffect, useState } from 'react';
import {
	Dialog,
	DialogContent,
	Typography,
	Select,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	Box,
	Stack,
	Grid,
	IconButton,
} from '@mui/material';
import {
	ClubDpRewardsCardLabelSX,
	ClubDpRewardsCardPointsIconSX,
	ClubDpRewardsMonthSelectSX,
	ClubDpRewardsTableAmountSX,
	ClubDpRewardsTitleSX,
} from '@/components/content/Account/styles/clubDpRewards';
import StarsIcon from '@mui/icons-material/Stars';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { UsePagination } from '@/components/blocks/UsePagination';
import { ConfirmCredentialsDialogHeaderSX } from '@/components/blocks/ConfirmCredentialsDialog/style';
import { ClearIcon } from '@mui/x-date-pickers';

interface PeriodsModalProps {
	open: boolean;
	onClose?: () => void;
	periods: any;
	balancePoints: any;
}
export const PeriodsModal: React.FC<PeriodsModalProps> = ({
	periods,
	open,
	onClose,
	balancePoints,
}) => {
	const [selectedMonth, setSelectedMonth] = useState<string>(periods[0].month);
	const [page, setPage] = useState<number>(1);
	const rowsPerPage = 5;

	const handleMonthChange = (event: any) => {
		setSelectedMonth(event.target.value);
		setPage(1);
	};

	const handleChangePage = (event: any, newPage: any) => {
		setPage(newPage);
	};

	const currentData = periods.find((d: any): any => d.month === selectedMonth)?.transactions || [];
	const paginatedData = currentData.slice((page - 1) * rowsPerPage, page * rowsPerPage);

	useEffect(() => {
		setSelectedMonth(periods[0].month);
	}, [open, periods]);

	return (
		<Dialog open={open} onClose={onClose} fullWidth>
			<DialogContent>
				<Box sx={ConfirmCredentialsDialogHeaderSX} marginBottom={'18px'}>
					<Typography sx={ClubDpRewardsTitleSX}>{'ESTADO DE CUENTA DP REWARDS'}</Typography>
					<Stack>
						<IconButton onClick={onClose}>
							<ClearIcon />
						</IconButton>
					</Stack>
				</Box>
				<Stack spacing={2}>
					<Stack flexDirection={'row'} alignItems={'center'}>
						<StarsIcon sx={ClubDpRewardsCardPointsIconSX} />
						<Typography margin={'0px 5px'} sx={ClubDpRewardsTitleSX}>
							{'Saldo dp puntos al día de hoy:'}
						</Typography>
						<Typography
							fontSize="var(--font-size-md)"
							sx={ClubDpRewardsTableAmountSX}
						>{`${balancePoints} puntos`}</Typography>
					</Stack>
					<Stack direction="row" spacing={2} alignItems="center" justifyContent={'space-between'}>
						<Typography sx={ClubDpRewardsTitleSX}>{'Últimos movimientos'}</Typography>
						<Select
							value={selectedMonth}
							onChange={handleMonthChange}
							displayEmpty
							sx={ClubDpRewardsMonthSelectSX}
							IconComponent={(props) => <KeyboardArrowDownIcon {...props} />}
						>
							{periods.map((d: any) => {
								const formattedMonth = d.month.replace(' - ', ' ');

								return (
									<MenuItem key={d.month} value={d.month}>
										{formattedMonth}
									</MenuItem>
								);
							})}
						</Select>
					</Stack>

					{paginatedData && paginatedData.length > 0 ? (
						<TableContainer component={Box} sx={{ mb: 2 }}>
							<Table>
								<TableBody>
									{paginatedData.map((transaction: any, index: any) => (
										<TableRow
											key={index}
											sx={{
												backgroundColor: index % 2 === 0 ? '#F8FCFF' : '#F2F8FF',
												border: '1px solid #F1F1F1',
												borderRadius: '4px',
												marginBottom: '2px',
												'&:last-child': {
													marginBottom: 0,
												},
											}}
										>
											<TableCell>
												{transaction.date}
												<Typography sx={ClubDpRewardsCardLabelSX}>
													{`${transaction.storeName} - ${transaction.hour}`}
												</Typography>
											</TableCell>
											<TableCell sx={{ textAlign: 'right', paddingRight: '16px' }}>
												<Typography>{'Acumulaste'}</Typography>
												<Typography
													sx={ClubDpRewardsTableAmountSX}
												>{`${transaction.amount} puntos`}</Typography>
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
							{Math.ceil(currentData.length / rowsPerPage) > 1 ? (
								<Grid sx={{ mt: '28px', pt: '16px', borderTop: '1px solid #D9D9D9' }}>
									<UsePagination
										onChange={handleChangePage}
										count={Math.ceil(currentData.length / rowsPerPage)}
										page={page}
									/>
								</Grid>
							) : null}
						</TableContainer>
					) : (
						<Typography>{'No hay movimientos para el mes seleccionado.'}</Typography>
					)}
				</Stack>
			</DialogContent>
		</Dialog>
	);
};
